'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENTERPRISE_EVENT_BUS_ID = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTERPRISE_EVENT_BUS_ID = exports.ENTERPRISE_EVENT_BUS_ID = '__cw_enterprise_event_bus';
var HOST_MODULE_ID = 'host';

/**
* @typedef {Object} EnterpriseEventBusEvent
* @property {string} originModuleId
* @property {string} targetModuleId
* @property {string} eventName
* @property {any} [args]
*/

var _moduleId = void 0;

var EnterpriseEventBus = function () {
  function EnterpriseEventBus() {
    (0, _classCallCheck3.default)(this, EnterpriseEventBus);
  }

  (0, _createClass3.default)(EnterpriseEventBus, null, [{
    key: 'isInjected',

    /**
     * Determines if EnterpriseEventBus is injected
     * @returns {boolean}
     */
    value: function isInjected() {
      return window[ENTERPRISE_EVENT_BUS_ID];
    }

    /**
     * Define intended target moduleId for module
     * @param {string} moduleId
     * @param {function} initCallback
     */

  }, {
    key: 'initialize',
    value: function initialize(moduleId, initCallback) {
      _moduleId = 'cw-manage-' + moduleId.toLowerCase();

      EnterpriseEventBus.addHandler('load', initCallback);
    }

    /**
     * Subscribes to event
     * @param {string} eventName
     * @param {function} handler
     */

  }, {
    key: 'addHandler',
    value: function addHandler(eventName, handler) {
      if (!EnterpriseEventBus.isInjected()) {
        return;
      }

      return window[ENTERPRISE_EVENT_BUS_ID].addHandler(eventName, function (evt, callback) {
        if (typeof evt !== 'string') {
          return;
        }

        /** @type {EnterpriseEventBusEvent} */
        var event = JSON.parse(evt);

        //ignore messages sent from myself
        if (event.originModuleId === _moduleId) {
          return;
        }

        // only invoke handler on broadcast messages and messages specifically intended for module
        if (!event.targetModuleId || event.targetModuleId === _moduleId) {
          var cb = callback ? function (json) {
            callback((0, _stringify2.default)(json));
          } : null;
          handler(event, cb);
        }
      });
    }

    /**
     * Publishes event
     * @param {string} eventName
     * @param {any} [args]
     * @param {function} [callback]
     * @param {string} [targetModuleId]
     */

  }, {
    key: 'fire',
    value: function fire(eventName) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var targetModuleId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : HOST_MODULE_ID;

      if (!EnterpriseEventBus.isInjected()) {
        return;
      }

      /** @type {EnterpriseEventBusEvent} */
      var event = {
        originModuleId: _moduleId,
        targetModuleId: targetModuleId,
        eventName: eventName,
        args: args
      };

      window[ENTERPRISE_EVENT_BUS_ID].fire(eventName, (0, _stringify2.default)(event), callback);
    }

    /**
     * Broadcasts event to all listeners
     * @param {string} eventName
     * @param {any} [args]
     */

  }, {
    key: 'broadcast',
    value: function broadcast(eventName) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      EnterpriseEventBus.fire(eventName, args, undefined, '');
    }
  }]);
  return EnterpriseEventBus;
}();

exports.default = EnterpriseEventBus;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/EnterpriseEventBus.js
// module id = 148
// module chunks = 10